<template>
  <div>

    <vx-card>

      <vs-table-mod :data="liveClassSchedules"
                    :max-items="tableConfig.minItemsPerPage"
                    pagination
                    search
      >

        <template slot="header-left">
          <div class="vx-col md:w-1/6 sm:w-1/3">
            <v-select :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" :options="academicPeriods"
                      @input="onAcademicPeriodChange" class="mb-4 md:mb-0"
                      label="periodCode"
                      selectOnTab
                      v-model="local.selectedAcademicPeriod">

              <!--label option-->
              <template #selected-option="{ periodCode }">
                {{ periodCode }}
              </template>

              <!--option list-->
              <template v-slot:option="option">
                {{ option.periodCode }}
              </template>

            </v-select>
          </div>

        </template>

        <template slot="thead"
                  v-for="(thead, indexth) in table.header"
        >
          <vs-th :key="indexth" :sort-key="thead.id" :width="thead.width">
            {{ $t(thead.title) }}
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr
            :data="{ data: tr, index: indextr }"
            :key="indextr"
            v-for="(tr, indextr) in data"
          >
            <vs-td width="40">
              {{ indextr + 1 }}
            </vs-td>
            <vs-td>
              {{ tr.subjectCode }} {{ $t('live-class-schedule.section')}} {{ tr.sectionNo }}
              <br>
              {{ tr.subject.nameLocal }}
            </vs-td>
            <vs-td>
              {{ moment(tr.dateTimeFrom).format(dateTimeFormat.momentYYYYMMDD) }}
              <br>
              {{ moment(tr.dateTimeFrom).format(dateTimeFormat.momenthhmm) }} - {{
              moment(tr.dateTimeTo).format(dateTimeFormat.momenthhmm) }}
            </vs-td>

            <vs-td>
              <div class="flex items-center text-break">
                <vs-avatar :src="tr.teacher.picturePath ? tr.teacher.picturePath:''" class="flex-shrink-0 mr-2"
                           size="30px"
                />
                {{ tr.teacher | teacherName }}
              </div>
            </vs-td>
            <vs-td>
              {{ tr.topicLocal }}
            </vs-td>
            <vs-td>
              {{ tr.remark }}
            </vs-td>
            <vs-td>
              <vs-chip :color="tr.isEnabled ? 'success': 'grey'"></vs-chip>
            </vs-td>

            <vs-td class="whitespace-no-wrap" width="100">
              <feather-icon @click="onEditClick(tr)" icon="EditIcon"
                            svgClasses="w-5 h-5 hover:text-primary stroke-current"/>
            </vs-td>

          </vs-tr>
        </template>
      </vs-table-mod>

    </vx-card>

  </div>
</template>

<script>
  import {state, template, loadData, initData} from '../data';
  import {tableConfig} from '@/utils/table'
  import {showStateNotification} from '@/utils/notification'
  import moment from 'moment';
  import {dateTimeFormat} from '@/utils/format';

  import LiveClassSchedule from '@/store/modules/live-class/live-class-schedule/index';
  import AcademicPeriod from '@/store/modules/common-data/academic-period';
  import AcademicPeriodConfig from '@/store/modules/common-data/academicPeriodConfig';
  import {createHelpers} from 'vuex-map-fields';
  import {createNamespacedHelpers} from "vuex";
  import vSelect from "vue-select";

  if (!state.store.LiveClassSchedule) state.registerModule(`LiveClassSchedule`, LiveClassSchedule);
  if (!state.store.AcademicPeriod) state.registerModule(`AcademicPeriod`, AcademicPeriod);
  if (!state.store.AcademicPeriodConfig) state.registerModule(`AcademicPeriodConfig`, AcademicPeriodConfig);

  const {
    mapActions: mapAcademicPeriodActions,
  } = createNamespacedHelpers(`AcademicPeriod`);
  const {
    mapActions: mapAcademicPeriodConfigActions,
  } = createNamespacedHelpers(`AcademicPeriodConfig`);
  const {
    mapActions: mapLiveClassScheduleActions,
  } = createNamespacedHelpers(`LiveClassSchedule`);


  const {
    mapFields: mapAcademicPeriodFields,
  } = createHelpers({
    getterType: `AcademicPeriod/getField`,
    mutationType: `AcademicPeriod/updateField`,
  });
  const {
    mapFields: mapAcademicPeriodConfigFields,
  } = createHelpers({
    getterType: `AcademicPeriodConfig/getField`,
    mutationType: `AcademicPeriodConfig/updateField`,
  });
  const {
    mapFields: mapLiveClassScheduleFields,
  } = createHelpers({
    getterType: `LiveClassSchedule/getField`,
    mutationType: `LiveClassSchedule/updateField`,
  });


  export default {
    components: {
      vSelect,
      vsTableMod: () => import('@/components/vuesax-mod/components/vsTable/vsTable.vue'),
    },
    data() {
      return {
        store: state.store,
        local: state.local,
        table: template.table,
        tableConfig: tableConfig,

        moment: moment,
        dateTimeFormat: dateTimeFormat,

        openEditPopUp: false,
      }
    },
    computed: {
      ...mapAcademicPeriodFields({academicPeriodProcessing: 'processing'}),
      ...mapAcademicPeriodConfigFields({academicPeriodConfigProcessing: 'processing'}),
      ...mapLiveClassScheduleFields({
        liveClassScheduleProcessing: 'processing',
        liveClassScheduleSuccess: 'success',
        liveClassScheduleError: 'error'
      }),
      academicPeriods() {
        return state.store.AcademicPeriod.academicPeriods;
      },
      liveClassSchedules() {
        return this.local.liveClassSchedules;
      },
      teachers() {
        return state.store.Teacher.teachersDdl;
      },
    },
    watch: {
      academicPeriodProcessing(data) {
        this.local.isProcessing = data;
      },
      academicPeriodConfigProcessing(data) {
        this.local.isProcessing = data;
      },
      liveClassScheduleProcessing(data) {
        this.local.isProcessing = data;
      },
      liveClassScheduleSuccess(data) {
        showStateNotification(this.$vs, data);
      },
      liveClassScheduleError: async function (data) {
        showStateNotification(this.$vs, data);
      },
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapAcademicPeriodActions({
        getAcademicPeriods: 'getAcademicPeriods',
      }),
      ...mapAcademicPeriodConfigActions({
        getCurrentAcademicPeriodConfig: 'getCurrentAcademicPeriodConfig',
      }),
      ...mapLiveClassScheduleActions({
        getLiveClassSchedulesByFilterForTable: 'getLiveClassSchedulesByFilterForTable',
        deleteLiveClassSchedule: 'deleteLiveClassSchedule',
      }),
      //---------------------------------------- Event Function ------------------------------------------------------//
      async onEditClick(tr) {
        this.$router.push(
          {
            name: "vdo-live-set-edit",
            params: {
              liveClassScheduleId: tr.id
            }
          }
        );

      },
      async onAcademicPeriodChange() {
        await this.loadData();
      },
      //---------------------------------------- Local Function ------------------------------------------------------//
      async removeLiveClassSchedule(payload) {
        let result = await this.deleteLiveClassSchedule(payload);
        if (result) {
          await this.loadData();
        }
      },
      async initData() {
        let func = {
          getAcademicPeriods: this.getAcademicPeriods,
          getCurrentAcademicPeriodConfig: this.getCurrentAcademicPeriodConfig,
        };

        await initData(func);

      },
      async loadData() {
        let func = {getLiveClassSchedulesByFilterForTable: this.getLiveClassSchedulesByFilterForTable};
        await loadData(func);
      },
    },
    async mounted() {
      await this.initData();
      await this.loadData();
    }
  }
</script>

<style scoped>

</style>
